import { Link, Outlet, useMatch } from 'react-router-dom';
import { KbWatcher } from '@features/kb-watch';
import { MobileGuard } from '@shared/mobile-guard';
import { COMPANY } from '@shared/legal';
import { AppNav } from './AppNav';

/**
 * Каркас кабинета v2: левое меню + страница. Верхнюю строку рисует сама страница
 * (у каждой своя — см. TopBar). Внизу — реквизиты и правовые ссылки (требование ЮKassa).
 */
export function AppShell() {
  // Тест-чат и «Операторы» — на всю высоту окна, страница не прокручивается: подвал не показываем.
  const testChat = !!useMatch('/assistants/:id/test-chat');
  const operators = !!useMatch('/operators');
  const fullHeight = testChat || operators;
  return (
    <MobileGuard>
      <div className="v2-app">
        <AppNav />
        <div className="v2-main">
          <main style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <Outlet />
          </main>
          {!fullHeight && (
            <footer className="v2-legal">
              <Link to="/pricing">Тарифы</Link>
              <Link to="/legal/terms">Пользовательское соглашение</Link>
              <Link to="/legal/privacy">Политика конфиденциальности</Link>
              <Link to="/legal/requisites">Реквизиты</Link>
              <span style={{ marginLeft: 'auto' }}>
                {COMPANY.shortName} · ИНН {COMPANY.inn} · ОГРН {COMPANY.ogrn}
              </span>
            </footer>
          )}
        </div>
      </div>
      <KbWatcher />
    </MobileGuard>
  );
}
